export interface PlaceholderVariant {
  id: string
  name: string
  tooltip?: string
}

export function placeholders(variants: PlaceholderVariant[]) {
  return variants.map((variant) => ({
    ...variant,
    tooltip: variant.tooltip ?? formatDefaultTooltip(variant.name),
  }))
}

const variantsTypes = [
  ['', 'title case', (text: string) => text],
  ['u', 'upper case', (text: string) => text.toUpperCase()],
  ['l', 'lower case', (text: string) => text.toLowerCase()],
] as const

export function autoVariants(
  baseId: string,
  baseName: string,
  variantPosition: 'begin' | 'end' = 'begin',
): PlaceholderVariant[] {
  return variantsTypes.map(([mark, caseName, format]) => {
    const id =
      variantPosition === 'begin' ? `${mark}${baseId}` : `${baseId}${mark}`
    const name = format(baseName)

    return { id, name, tooltip: formatDefaultTooltip(name, caseName) }
  })
}

export function formatDefaultTooltip(base: string, caseName?: string) {
  return `This will show the ${base.toLowerCase()} that you've set${
    caseName ? ` in ${caseName}` : ''
  }`
}

const customNameOptions = autoVariants('name', 'Custom Name')
const fanNameOptions = autoVariants('nick', 'Fan Name')
const firstFanNameOptions = autoVariants('fnick', 'First Fan Name', 'end')

export const variants = {
  customNameOptions,
  fanNameOptions,
  firstFanNameOptions,
}

const variantTable = new Map<string, PlaceholderVariant>(
  Object.values(variants)
    .flatMap((variant) => variant)
    .map((variant) => [variant.id, variant]),
)

export function detectVariant(id: string): PlaceholderVariant | undefined {
  return variantTable.get(id)
}
